import React from 'react'
import { SkuVasDetail } from '../../../../components/CaptureVasRule/types'
import { TableColumn } from '../../../_EOS/GenericTable'
import { Avatar, Chip } from '@mui/material'
import { EnumPickingValidate } from '../../pickingValidateConfig'

export const getColumnsConfig = (): TableColumn<SkuVasDetail>[] => [
  {
    key: 'urlImage',
    title: 'FOTO',
    sortable: false,
    render: (image: unknown) => setImage(image as string)
  },
  {
    key: 'sku',
    title: 'SKU/EAN',
    render: (_, row: SkuVasDetail) => (
      <div style={{ fontSize: '0.85rem' }}>
        {row.eaN13 === row.sku
          ? row.sku.toString()
          : `${row.sku} / ${row.eaN13}`}
      </div>
    )
  },
  { key: 'realQty', title: 'Sol' },
  { key: 'pickedQty', title: 'Pick' },
  { key: 'validatedQty', title: 'Val' },
  {
    key: 'commentary',
    title: 'Obs',
    sortable: false,
    render: (_id: unknown) => setComentary(_id)
  }
]

const setImage = (pImage: string) => {
  const image =
    pImage !== undefined
      ? pImage
      : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

  return (
    <Avatar
      style={{ height: '100px', width: '100px', textAlign: 'center' }}
      variant='square'
      alt='SkuImage'
      src={image}
    />
  )
}

const setComentary = (comentaryId: unknown) => {
  return (
    <Chip
      size='small'
      label={
        EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
          ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0].name
          : ''
      }
      variant='outlined'
      style={{
        backgroundColor:
          EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
            ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0]
                .color
            : '',
        color:
          EnumPickingValidate.filter((obs) => obs.id === comentaryId).length > 0
            ? EnumPickingValidate.filter((obs) => obs.id === comentaryId)[0]
                .textColor
            : '',
        fontWeight: 'bold'
      }}
    />
  )
}
